import RewardsClient from '@/api/RewardsClient';
import featureFlagSlugs from '@/constants/featureFlagSlugs';
import { dealershipTypes } from '@/constants/dealershipTypes';

export default {
  state: {
    loyaltyMap: new Map(),
    isRewardsProgramEligible: false,
  },
  actions: {
    async checkEligibilityToRewardsProgram({
      dispatch,
      rootState,
      commit,
    }) {
      const ffLoyaltyEnabled = await dispatch('getFlag', featureFlagSlugs.enableAcvLoyaltyProduct, { root: true });
      const multiDealerFeatureFlag = await dispatch('getFlag', featureFlagSlugs.enableAcvLoyaltyMultiDealer, { root: true });
      const dealerType = rootState.authorization.user.defaultDealer.dealership.dealership_type;
      const defaultDealerId = rootState.authorization.user.defaultDealer.dealership.id;
      let hasEligibleDealerType = false;
      if ([dealershipTypes.independent, dealershipTypes.acvCertifiedIndependent]
        .includes(dealerType)) {
        hasEligibleDealerType = true;
      }

      const isLoyaltyProgramEnabled = ffLoyaltyEnabled && hasEligibleDealerType;

      if (isLoyaltyProgramEnabled) {
        const api = new RewardsClient();
        let eligibilityData = [];
        try {
          if (multiDealerFeatureFlag) {
            eligibilityData = await api.getRewardsProgramEligibility();
          } else {
            const dealerEligibility = await api.isRewardsProgramEligible(defaultDealerId);
            eligibilityData = [{ dealerId: defaultDealerId, eligible: dealerEligibility }];
          }
          eligibilityData.forEach(({ dealerId, eligible }) => {
            commit('setEligibilityStatus', { dealerId, eligible });
            const dealerName = rootState.authorization.user.activeDealerships[dealerId]?.name || 'Unknown Dealer';
            commit('setDealerName', { dealerId, dealerName });
            if (dealerId === defaultDealerId) {
              commit('setIsRewardsProgramEligible', eligible);
            }
          });
        } catch {
          commit('setIsRewardsProgramEligible', false);
        }
      }
    },
    async refreshRewardsEnrollmentStatus({ commit }) {
      const api = new RewardsClient();
      const enrollmentData = await api.getRewardsEnrollmentStatus();
      enrollmentData.forEach(({ dealerId, enroll }) => {
        commit('updateEnrollmentStatus', { dealerId, enrolledToRewards: enroll });
      });
    },
    async optIntoLoyaltyProgram(_, dealerIds) {
      const api = new RewardsClient();
      await api.joinLoyaltyProgram(dealerIds);
    },
  },
  mutations: {
    setIsRewardsProgramEligible(state, eligibility) {
      state.isRewardsProgramEligible = eligibility;
    },
    setEligibilityStatus(state, { dealerId, eligible }) {
      if (state.loyaltyMap.has(dealerId)) {
        state.loyaltyMap.get(dealerId).eligible = eligible;
      } else {
        state.loyaltyMap.set(dealerId, { eligible });
      }
    },
    setDealerName(state, { dealerId, dealerName }) {
      if (state.loyaltyMap.has(dealerId)) {
        state.loyaltyMap.get(dealerId).name = dealerName;
      } else {
        state.loyaltyMap.set(dealerId, { dealerName });
      }
    },
    updateEnrollmentStatus(state, { dealerId, enrolledToRewards }) {
      state.loyaltyMap.set(dealerId, {
        ...state.loyaltyMap.get(dealerId),
        enrolledToRewards,
      });
    },
  },
  getters: {
    getLoyaltyMap: (state) => new Map(state.loyaltyMap),
  },
};
